<template>
	<div>

        <ViewItem v-if='show_view' @close='show_view = false;' :item="action_item" />
        <AddItem v-if='show_add' @close='show_add = false;' @added="added_item" />
        <EditItem v-if='show_edit' @close='show_edit = false;' @updated="update_item" :item="action_item" />
        <DeleteItem v-if='show_delete' @close='show_delete = false;' @updated="deleted_item" :item="action_item" />

        <!-- Filter item Modal -->
		<div class="modal fade show" id="modal-default" tabindex="-1" style="display: block;" aria-modal="true" v-if='show_filter_modal'>
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Filter Item List</h5><i class="modal-close zwicon-close pull-right display-4" @click='close_filters'></i>
					</div>
					<div class="modal-body">
						<div class='row mt-0'>
							<div class='col-md-12'>
								<div class="form-group mb-0">
									<label>Search Items</label>
									<input class="form-control" v-model='filter.search' placeholder='Search Name or Email...'/>
								</div>
							</div>
						</div>

						<div class='row mt-3'>
							<div class='col-md-6'>
								<div class="form-group mb-0">
									<label>Category</label>
									<select class="form-control" v-model='filter.category'>
										<option value="">-</option>
                                        <option v-for="category in category_list.list" v-bind:key="category" :value="category.configuration_id">{{category.name}}</option>
									</select>
									
								</div>
							</div>
							<div class='col-md-6'>
								<div class="form-group mb-0">
									<label>Description</label>
									<select class="form-control" v-model='filter.description'>
										<option value="">-</option>
                                        <option v-for="description in filtered_description_list" v-bind:key="description" :value="description.configuration_id">{{description.name}}</option>
									</select>
									
								</div>
							</div>
						</div>

						<div class='row mt-3'>
							<div class='col-md-6'>
								<div class="form-group mb-0">
									<label>Pin Conn</label>
									<select class="form-control" v-model='filter.pinn_conn'>
										<option value="">-</option>
                                        <option v-for="pin_conn in connector_list.list" v-bind:key="pin_conn" :value='pin_conn.configuration_id'>{{pin_conn.name}}</option>
									</select>
									
								</div>
							</div>
							<div class='col-md-6'>
								<div class="form-group mb-0">
                                    <label>Box Conn</label>
                                    <select class="form-control" v-model='filter.box_conn'>
                                        <option value="">-</option>
                                        <option v-for="box_conn in connector_list.list" v-bind:key="box_conn" :value='box_conn.configuration_id'>{{box_conn.name}}</option>
                                    </select>
                                    
								</div>
							</div>
						</div>

                        <div class='row mt-3'>
                            <div class='col-md-6'>
                                <div class="form-group mb-0">
                                    <label>Size</label>
									<select class="form-control" v-model='filter.size'>
										<option value="">-</option>
                                        <option v-for="size in size_list.list" v-bind:key="size" :value='size.configuration_id'>{{size.name}}</option>
									</select>                        
                                </div>
                            </div>
                             <div class='col-md-6'>
                                <div class="form-group mb-0">
                                    <label>In/Out</label>
									<select class="form-control" v-model='filter.wheremst'>
										<option value="">-</option>
                                        <option value="true">In</option>
                                        <option value="false">Out</option>
									</select>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-3'>
                            <div class='col-md-6'>
                                <div class="form-group mb-0">
                                    <label>Dirty</label>
									<select class="form-control" v-model='filter.dirty_girl'>
										<option value="">-</option>
                                        <option value="true">Dirty</option>
                                        <option value="false">Clean</option>
									</select>                        
                                </div>
                            </div>
                        </div>
					</div>
					<ErrorMessage :message='filter_error' v-if='filter_error.length > 0' />
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" @click='apply_filters'>Apply Filters</button>
						<button type="button" class="btn btn-secondary" @click='clear_filters'>Clear Filters</button>
					</div>
				</div>
			</div>
		</div>
		<!-- End filter item Modal -->

        <div class="container-fluid">
            <div class="card mt-3">

                <div class="card-body">
                    <h4 class="card-title">Inventory</h4>
                    <div class="actions">
                    <button v-if="getPermission('inventory', 'add')" class="btn btn-primary btn--icon-text ml-3 mr-3" v-tooltip="'Add a Item'" @click='add_item()'><i class="zwicon-plus"></i> Add Item</button>
                                    
                    </div>
                    
                    <div class="table-responsive data-table table-sm table-striped">
                        <div id="data-table_wrapper" class="dataTables_wrapper no-footer">
                            
                            <div class="dataTables__top">
                                <div id="data-table_filter" class="dataTables_filter">
                                    <label>Search:<input type="search" class="" v-model="searchterm" v-on:keyup.enter="search" placeholder="Search for records..." aria-controls="data-table"></label>
                                </div>
                                <div class="dataTables_length">
                                    <a class="btn btn-primary pl-5 btn-block text-left" @click='open_filters' role="button">View Filters</a>
                                </div>
                            </div>

                            <div class='' v-if='has_filters'>
                                <div class='badge badge-info mr-2' v-if='searched_filter.search !== ""'><b>Searched</b>: {{searched_filter.search}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("search")'><i class="zwicon-close"></i></a></div>
                                <div class='badge badge-info mr-2' v-if='searched_filter.category !== ""'><b>Category</b>: {{category_name(searched_filter.category)}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("category")'><i class="zwicon-close"></i></a></div>
                                <div class='badge badge-info mr-2' v-if='searched_filter.description !== ""'><b>Description</b>: {{description_name(searched_filter.description)}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("description")'><i class="zwicon-close"></i></a></div>
                                <div class='badge badge-info mr-2' v-if='searched_filter.size !== ""'><b>Size</b>: {{size_name(searched_filter.size)}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("size")'><i class="zwicon-close"></i></a></div>
                                <div class='badge badge-info mr-2' v-if='searched_filter.pinn_conn !== ""'><b>Pin Conn</b>: {{connection_name(searched_filter.pinn_conn)}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("pinn_conn")'><i class="zwicon-close"></i></a></div>
                                <div class='badge badge-info mr-2' v-if='searched_filter.box_conn !== ""'><b>Box Conn</b>: {{connection_name(searched_filter.box_conn)}} <a class='badge-secondary badge p-1 ml-2 text-white' @click='clear_filter("box_conn")'><i class="zwicon-close"></i></a></div>
                            </div>
                            <div class='mb-3 text-right'>
                                <div class="icon-toggle">
                                    <input type="checkbox" id="show-comments" v-model='show_comments'>
                                    <i class="zwicon-checkmark text-success" v-if="show_comments"></i>
                                    <i class="zwicon-note" v-if="!show_comments"></i>
                                </div>
                                <label for="show-comments">&nbsp;Show Comments</label>
                            </div>

                            <table id="data-table" class="table dataTable no-footer" role="grid" aria-describedby="data-table_info">
                            <thead class="table-dark">
                                <tr role="row">
                                    <th rowspan="1" colspan="1">Category</th>
                                    <th rowspan="1" colspan="1">Description</th>
                                    <th rowspan="1" colspan="1">Size</th>
                                    <th rowspan="1" colspan="1">Serial No.</th>
                                    <th rowspan="1" colspan="1">Pin Conn</th>
                                    <th rowspan="1" colspan="1">Box Conn</th>
                                    <th rowspan="1" colspan="1">In</th>
                                    <th rowspan="1" colspan="1">Out</th>
                                    <th rowspan="1" colspan="1">Pending</th>
                                    <th rowspan="1" colspan="1">SP</th>
                                    <th rowspan="1" colspan="1">RW</th>
                                    <th rowspan="1" colspan="1">Dirty</th>
                                    <th rowspan="1" colspan="1" v-if='show_comments'>Comments</th>
                                    <th rowspan="1" colspan="1">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in inventory_list.list" v-bind:key="item" :class="{'text-secondary':!item.active}">
                               
                                <td>
                                    {{category_name(item.category)}}
                                </td>
                                <td>
                                    {{description_name(item.description) || '-'}}     
                                </td>
                                <td>
                                    {{size_name(item.size) || ''}}     
                                </td>
                                <td>
                                    {{item.serial_no || ''}}
                                </td>
                                <td>
                                    {{connection_name(item.pinn_conn) || ''}}
                                </td>
                                <td>
                                    {{connection_name(item.box_conn) || ''}}
                                </td>
                                <td>
                                    <i v-if="item.in == 1" class="zwicon-checkmark-circle"></i>
                                </td>
                                <td>
                                    <i v-if="item.in == 0" class="zwicon-checkmark-circle"></i>
                                </td>
                                <td>
                                    <i v-if="item.pending == 'pending'" class="zwicon-checkmark-circle"></i>
                                </td>
                                <td>
                                   <i v-if="item.SP" class="zwicon-checkmark-circle" :class="{'text-success': item.SP}"></i>
                                </td>
                                <td>
                                    <i v-if="item.RW" class="zwicon-checkmark-circle" :class="{'text-success': item.RW}"></i>
                                </td>
                                <td>
                                    <i v-if="item.dirty" class="zwicon-checkmark-circle" :class="{'text-success': item.dirty}"></i>
                                </td>
                                <td v-if="show_comments">
                                    {{item.comments || ''}}
                                </td>
                                
                                <td style="text-align: right; position: relative;" v-if='item.inventory_id > 0' @click='toggle_v_dropdown(item.inventory_id)'>
                                    <button class="btn btn-primary btn-sm" v-tooltip="'Toggle User Menu'"><i class="zwicon-more-h"></i>&nbsp;Actions</button>
                                    <div class="dropdown-menu dropdown-menu-right" v-if='active_item.toString() == item.inventory_id.toString()' v-click-outside="toggle_v_dropdown"> <!--  v-if='user_dd["x"+user_item.user_id]' -->
                                        <a class="dropdown-item" @click='view_item(item)'>View</a>
                                        <a v-if="getPermission('inventory', 'edit')" class="dropdown-item" @click='edit_item(item)'>Edit</a>
                                        <a v-if="getPermission('inventory', 'delete')" class="dropdown-item" @click='delete_item(item)'>Delete</a>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                            
                            <div class='row mt-2' v-if='inventory_list.pagination !== undefined'>
                                <div class='col-md-6 pt-2'>Showing {{(inventory_list.pagination.per_page*inventory_list.pagination.page)+1}} to {{pagination_max}} of {{inventory_list.pagination.total_items}} items.</div>
                                <div class='col-md-6'>
                                    <div class="ml-auto" v-if='pages.length > 1'>
                                        <Pagination @set_page="view_page" :current_page='inventory_list.pagination.page' :pages='pages' />
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>

	import { mapGetters } from "vuex";
	import store from "@/store";

	import { LOAD_INVENTORY_LIST } from "@/store/actions.type";

    import ViewItem from '@/views/Inventory/Modals/ViewItem';
    import AddItem from '@/views/Inventory/Modals/AddItem';
    import EditItem from '@/views/Inventory/Modals/EditItem';
    import DeleteItem from '@/views/Inventory/Modals/DeleteItem';
    import PermissionService from "@/common/permission.service";
	import Pagination from '@/components/General/Pagination';

	export default {
		name: 'Inventory',
		components: {
            AddItem,
            ViewItem,
            EditItem,
            DeleteItem,
            Pagination
		},
		props: {
			error: {
				type: String,
				default: "" 
			},
			success: {
				type: String,
				default: ""
			}
		},
        data(){
            return {
                filter_list: false,
                active_item: '',
                show_view: false,
                show_add: false,
                show_edit: false,
                show_delete: false,
                show_filter_modal: false,
                success_msg: '',
				filter_error: '',
                filter: {
                    search: ''
                },
                show_comments: false,
                searchterm: ''
            }
        },
        mounted() {
            this.reset_filter_form();
			this.load_list(function(){
                console.log('try to load')
			}, function(){
                console.log('load error')
			});
		},
		computed: {
            pagination_max(){
				var page_max = (this.inventory_list.pagination.per_page*(this.inventory_list.pagination.page+1));
				if(page_max > this.inventory_list.pagination.total_items)  page_max = this.inventory_list.pagination.total_items;
				return page_max;
			},
            filtered_description_list(){
                if([null, false, ''].includes(this.filter.category)) return [];
                return this.description_list.list.filter(x => x.parent_configuration_id == this.filter.category);
            }, 
			pages(){
				let page_list = [];
				for(var i = 0;i < Math.ceil(this.inventory_list.pagination.total_items / this.inventory_list.pagination.per_page);i++){
					page_list.push((i*1)+1);
				}
				return page_list;
			},
			...mapGetters(['inventory_list', 'user', 'loading','size_list','category_list','connector_list','description_list'])
		},
        methods: {
            getPermission(category, permission){
				return PermissionService.getPermission(category, permission);
			},
            description_name(desc_id){
                
                if(this.description_list.list === undefined) return "";
                //console.log(this.description_list.list);
                let item = this.description_list.list.filter(x => x.configuration_id == desc_id);
                //console.log(item[0].name);
                if(item.length == 1) return item[0].name;
                else return '???';
            },
            category_name(desc_id){
                if(this.category_list.list === undefined) return "";
                let item = this.category_list.list.filter(x => x.configuration_id == desc_id);
                if(item.length == 1) return item[0].name;
                else return '???';
            },
            size_name(desc_id){
                if(this.size_list.list === undefined) return "";
                let item = this.size_list.list.filter(x => x.configuration_id == desc_id);
                if(item.length == 1) return item[0].name;
                else return '???';
            },
            connection_name(desc_id){
                if(this.connector_list.list === undefined) return "";
                let item = this.connector_list.list.filter(x => x.configuration_id == desc_id);
                if(item.length == 1) return item[0].name;
                else return '???';
            },
            toggle_v_dropdown(id){
                if(this.active_item == id) this.active_item = '';
                else this.active_item = id;
            },
			open_filters(){
				this.show_filter_modal = true;
			},
			close_filters(){
				this.show_filter_modal = false;
			},
            load_list(success_fn){
				this.list_loading = true;
				this.filter_error = "";
				console.log('load list')
                this.filter.search = this.searchterm;
				store.dispatch(LOAD_INVENTORY_LIST, this.filter).then(data => {
					success_fn(data);
				}).catch(()=>{}).finally(() => {
					this.list_loading = false;
				});
			},
            view_page(page){
				this.filter.page = page;
				this.load_list(this.close_filters, function(){
					this.success_msg = '';
					this.filter_error = '';
				});
			},
            view_item(item){
				this.action_item = item;
				this.show_view = true;
			},
            edit_item(item){
				this.action_item = item;
				this.show_edit = true;
			},
            add_item(){
				this.action_item = {};
				this.show_add = true;
			},
            update_item(new_item){
                this.show_edit = false;
                this.load_list();       
                new_item;
            },
            added_item(new_item){
                this.show_add = false;
                this.load_list();       
                new_item;
            },
            delete_item(new_item){
                this.action_item = new_item;
                this.show_delete = true;
            },
            deleted_item(){
                this.show_delete = false;
                this.load_list(); 
            },
            search(){
                this.load_list(() => {}, ()=>{});
            },
            clear_search(){
                this.filter.search = '';
                this.search();
            },
            clear_filter(key){
				this.filter[key] = '';
				this.apply_filters();
			},
			apply_filters(){
				this.searched_filter = Object.assign({}, this.filter);
				this.has_filters = false;
				['search', 'category', 'description', 'size', 'pinn_conn', 'box_conn', 'wheremst', 'dirty_girl'].forEach(key => {
					if(this.filter[key] !== "") this.has_filters = true;
				})
				this.load_list(this.close_filters, function(){
					//this.success = '';
					this.filter_error = '';
				});
			},
			clear_filters(){
				this.reset_filter_form();
				this.apply_filters();
			},
			reset_filter_form(){
				this.filter = {
					page: 0,
					search: '',
					category: '',
					description: '',
					size: '',
					pinn_conn: '',
                    box_conn: '',
                    wheremst: '',
                    dirty_girl: ''
				};
			}
            
        },
        watch: {
            searchterm(newdata){
                if(newdata != '') return;
                this.search();
            }
        }
	}
</script>